export default __webpack_public_path__ + "53daeb4a282583a715055b370257f9a7.svg";